export default {
	props: {
		calculation: {
			required: true
		}
	}
};
